export default __webpack_public_path__ + "static/media/watches.2a355edb.jpg";